import { WithChakra } from 'src/contexts/Chakra';
import { Customers, Referrals } from '../pages';

export const CustomerManagementRoutes = [
  {
    path: '/clientes',
    isPrivate: true,
    exact: true,
    component: <Customers />,
  },
  {
    path: '/indicar',
    exact: true,
    isPrivate: true,
    component: (
      <WithChakra>
        <Referrals />
      </WithChakra>
    ),
  },
];
